import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { debounce } from "lodash";

import Content from "../../../../Components/Dashboard/Content/Content";
import Loader from "../../../../Utils/Loader";
import Table from "../../../../Components/ExtraComponents/Tables/FullDataTable";

import {
  Get_All_Catagory,
  Service_By_Catagory,
} from "../../../../ReduxStore/Slice/Admin/AdminSlice";

import { usePrices } from "../../../../context/PriceContext";

const ServicesList = () => {
  const dispatch = useDispatch();
  const prices = usePrices(); 

  const [category, setCategory] = useState("all");
  const [services, setServices] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(true);
  const [servicesLoading, setServicesLoading] = useState(true);

  const [searchInput, setSearchInput] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false);
  const [broker, setBroker] = useState("DELTA");



  const getCategories = useCallback(async () => {
    try {
      await dispatch(Get_All_Catagory()).unwrap();
    } finally {
      setCategoriesLoading(false);
    }
  }, [dispatch]);

  useEffect(() => {
    getCategories();
  }, [getCategories, refresh]);

  const getServices = useCallback(async () => {
    setServicesLoading(true);
    try {
      const res = await dispatch(Service_By_Catagory({ category })).unwrap();

      setServices(res.status ? res.data : []);
    } catch {
      setServices([]);
    } finally {
      setServicesLoading(false);
    }
  }, [dispatch, category]);

  useEffect(() => {
    getServices();
  }, [getServices, refresh]);

  const debouncedSearch = useMemo(
    () =>
      debounce((value) => {
        setSearchInput(value);
      }, 400),
    []
  );

  const onSearchChange = (e) => {
    debouncedSearch(e.target.value);
  };

  const getBrokerPrice = (row) => {
    const servicePrices = prices?.[row.name];
    if (!servicePrices) return "-";

    switch (broker) {
      case "COINDCX":
        return roundSmart(servicePrices?.coindcx?.spot_price);

      case "DELTA":
        return roundSmart(servicePrices?.delta?.spot_price);

      // case "PI42":
      //   return roundSmart(servicePrices?.pi42?.spot_price);

      default:
        return "-";
    }
  };

  /* =========================
      Filtered Services
  ========================== */
  const filteredServices = useMemo(() => {
    if (!searchInput) return services;

    const term = searchInput.toLowerCase();
    return services.filter(
      (s) =>
        s.name.toLowerCase().includes(term) ||
        (s.category_info?.category || "").toLowerCase().includes(term)
    );
  }, [services, searchInput]);

  /* =========================
      Utils
  ========================== */
  // const roundSmart = (value) => {
  //   if (isNaN(value)) return "-";
  //   const abs = Math.abs(value);


  //   if (abs >= 1000) return value
  //   if (abs >= 1) return value
  //   if (abs >= 0.01) return value
  //   return value
  // };
  const roundSmart = (value) => {
    if (value === null || value === undefined || isNaN(value)) return "-";
    return Number(value).toFixed(3);
  };


  const columns = useMemo(
    () => [
      {
        name: "Service",
        cell: (row) => (
          <div className="d-flex align-items-center">
            {row.img && (
              <img
                src={row.img}
                alt=""
                width={40}
                height={40}
                className="rounded-circle me-2"
              />
            )}
            {row.name || "-"}
          </div>
        ),
        sortable: true,
        width: "220px",
      },
      {
        name: "Price",
        cell: (row) => {
          const price = prices?.[row.name];

          return price ? roundSmart(price?.spot_price) : "-";
        },
        sortable: true,
      },
      {
        name: "Min Quantity",
        selector: (row) => row.min_quantity || "N/A",
        sortable: true,
      },
      {
        name: "Risk Level",
        selector: (row) => row.risk_level || "-",
        sortable: true,
      },
    ],
    [prices]
  );

  const isLoading = servicesLoading || categoriesLoading || isSpinning;

  return (
    <Content Page_title="All Services" button_status={false}>
      <div className="row mb-3 filter-row">
        <div className="col-lg-3 col-md-4 col-8">
          <input
            className="form-control"
            placeholder="Search"
            onChange={onSearchChange}
          />
        </div>

        <div className="col-auto">
          <button
            className="btn btn-sm btn-primary"
            title="Reset Filters"
            onClick={() => {
              setIsSpinning(true);
              setSearchInput("");
              setCategory("all");
              setRefresh((p) => !p);
              setTimeout(() => setIsSpinning(false), 800);
            }}
          >
            <i className={`fa fa-refresh ${isSpinning ? "spin" : ""}`} />
          </button>
        </div>
        
        {/* <div className="col-auto dropdown">
          <button
            className="btn btn-sm btn-outline-primary dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
          >
            Broker: {broker}
          </button>

          <ul className="dropdown-menu p-3" style={{ minWidth: 220 }}>
            {[
              { label: "CoinDCX", value: "COINDCX" },
              { label: "Delta", value: "DELTA" },
              // { label: "Pi42", value: "PI42" },
            ].map((b) => (
              <li
                key={b.value}
                className="d-flex justify-content-between align-items-center mb-2"
              >
                <span>{b.label}</span>

                <div className="form-check form-switch m-0">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={broker === b.value}
                    onChange={() => setBroker(b.value)}
                  />
                </div>
              </li>
            ))}
          </ul>
        </div> */}

      </div>

      {isLoading ? (
        <div className="d-flex justify-content-center" style={{ height: 300 }}>
          <Loader />
        </div>
      ) : (
        <Table columns={columns} data={filteredServices} />
      )}
    </Content>
  );
};

export default ServicesList;
